export default {
  dataIterator: {
    pageText: '{0}-{1} of {2}',
    noResultsText: 'Pas trouvé',
    loadingText: "chargement d'éléments..."
  },
  dataFooter: {
    itemsPerPageText: 'Élements par page:',
    itemsPerPageAll: 'Tous',
    pageText: '{0}-{1} de {2}',
    nextPage: 'Page suivante',
    prevPage: 'Page précédente'
  },
  dataTable: {
    rowsPerPageText: 'Lignes par page:',
    itemsPerPageText: 'Élements par page:',
    ariaLabel: {
      sortNone: 'Sort None',
      activateAscending: 'Activate Ascending'
    }
  },
  datePicker: {
    prevMonthAriaLabel: 'Mois précédent',
    nextMonthAriaLabel: 'Mois suivant'
  },
  timePicker: {
    am: 'am',
    pm: 'pm'
  },
  noDataText: 'Aucune donnée disponible',
  helloText: 'Bonjour le monde!'
}
